export const jobReportingPlanModalStyles = {
  container: {
    display: 'flex',
    flexDirection: 'column',
    gap: 3,
    p: 3,
    maxHeight: '80vh',
    overflowY: 'auto',
  },
  statusSection: {
    p: 3,
    backgroundColor: 'background.paper',
    borderRadius: 2,
    border: '1px solid',
    borderColor: 'divider',
  },
  divider: {
    my: 3,
  },
  section: {
    display: 'flex',
    flexDirection: 'column',
  },
  sectionTitle: {
    fontWeight: 600,
    fontSize: '1.1rem',
    color: 'text.primary',
  },
  reportsHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    mb: 3,
    p: 2,
    backgroundColor: 'grey.50',
    borderRadius: 2,
  },
  reportCard: {
    p: 3,
    border: '1px solid',
    borderColor: 'divider',
    borderRadius: 2,
    backgroundColor: 'background.paper',
    boxShadow: '0 2px 4px rgba(0,0,0,0.05)',
    mb: 2,
  },
  reportHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    mb: 3,
    pb: 2,
    borderBottom: '1px solid',
    borderColor: 'divider',
  },
  reportTitle: {
    fontWeight: 600,
    fontSize: '1rem',
    color: 'primary.main',
  },
  deleteButton: {
    color: 'error.main',
    borderColor: 'error.main',
    '&:hover': {
      backgroundColor: 'error.light',
      color: 'error.contrastText',
    },
  },
  addButton: {
    backgroundColor: 'primary.main',
    color: 'primary.contrastText',
    '&:hover': {
      backgroundColor: 'primary.dark',
    },
  },
  actions: {
    display: 'flex',
    justifyContent: 'flex-end',
    gap: 2,
    mt: 4,
    pt: 3,
    borderTop: '1px solid',
    borderColor: 'divider',
  },
  radioGroup: {
    mt: 2,
    '& .MuiFormControlLabel-root': {
      marginBottom: 1,
    },
  },
  noReportsAlert: {
    mt: 2,
    p: 3,
    backgroundColor: 'info.50',
    border: '1px solid',
    borderColor: 'info.200',
    borderRadius: 2,
  },
  reportsContainer: {
    maxHeight: '400px',
    overflowY: 'auto',
    pr: 1,
  },
};
